import { Grid, Typography, Box } from "@mui/material"
import type { orderItem as OrderItemType } from './VerificationType'
import { Fragment } from "react"

type connectionList = {
  department: string,
  email_list: string[],
  sms_list: string[],
  key_list: string[],
  transfer_list: string[],
}

type question = {
  question: string,
  question_attibute: string,
  question_type: string
}

type configType = {
  indial_number: string,
  indial_city: string,
  sign_off: string,
  greeting_message: string,
  email_subject: string,
  full_name_required: number,
  business_name: string,
  caller_hung_up: string,
  connection_type: string,
  connection_list: connectionList[]
  additional_questions: question[]
}

const hungup = {
  sendcallswithid: 'be notified of missed calls from numbers with caller ID',
  noemptymsg: 'not be notified of missed calls',
  sendallcalls: 'be notified of all missed calls'
}

const labelStyle = { color: '#7A97B0', fontSize: '14px!important', fontWeight: 400 }
const valueStyle = { fontWeight: 500, fontSize: '14px!important', color: '#242424' }
const treeConnector = {
  borderLeft: '1px solid #ccc',
  borderBottom: '1px solid #ccc',
  width: '12px',
  height: '14px',
  display: 'inline-block',
  mr: 1,
  ml: 1,
  mt: '-3px',
  alignSelf: 'flex-start',
  flexShrink: 0,
}

const LiveAnsweringConfig = ({ orderItem }: { orderItem: OrderItemType }) => {
  const config: configType = orderItem.config
  type hungupKeyType = keyof typeof hungup
  const hungupKey = config.caller_hung_up as hungupKeyType
  return <Grid container spacing={1.5}>
    <Grid item sm={6}>
      <Typography sx={labelStyle}>Indial number</Typography>
      <Typography sx={valueStyle}>{config.indial_number}</Typography>
    </Grid>
    <Grid item sm={6}>
      <Typography sx={labelStyle}>Indial city</Typography>
      <Typography sx={valueStyle}>{config.indial_city}</Typography>
    </Grid>
    <Grid item sm={6}>
      <Typography sx={labelStyle}>Greeting message</Typography>
      <Typography sx={valueStyle}>{config.greeting_message}</Typography>
    </Grid>
    <Grid item sm={6}>
      <Typography sx={labelStyle}>Business name</Typography>
      <Typography sx={valueStyle}>{config.business_name}</Typography>
    </Grid>
    <Grid item sm={6}>
      <Typography sx={labelStyle}>Sign off message</Typography>
      <Typography sx={valueStyle}>{config.sign_off}</Typography>
    </Grid>
    <Grid item sm={6}>
      <Typography sx={labelStyle}>Email subject</Typography>
      <Typography sx={valueStyle}>{config.email_subject}</Typography>
    </Grid>
    <Grid item sm={6}>
      <Typography sx={labelStyle}>Hungup calls</Typography>
      <Typography sx={valueStyle}>{hungup[hungupKey]}</Typography>
    </Grid>
    {config.additional_questions.length > 0 && <Grid item sm={6}>
      <Typography sx={labelStyle}>Additional Question(s)</Typography>
      {config.additional_questions.map((question, key) => {
        return <Typography key={key} sx={valueStyle}>{question.question}</Typography>
      })}
    </Grid>}
    <Grid item xs={12}>
      <Typography sx={labelStyle}>Contacts</Typography>
      <Grid container spacing={1}>
        {config.connection_list.map((connection, key) => {
          return <Fragment key={key}>
            <Grid item xs={4} sm={3}>
              <Typography sx={{ ...valueStyle, mb: 0.5 }}>Department:</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={treeConnector} />
                <Typography sx={{ fontSize: '14px!important', color: '#242424' }}>{connection.department}</Typography>
              </Box>
            </Grid>
            <Grid item xs={4} sm={3}>
              <Typography sx={{ ...valueStyle, mb: 0.5 }}>Email(s):</Typography>
              {connection.email_list.map(email => (
                <Box key={email} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={treeConnector} />
                  <Typography sx={{ fontSize: '14px!important', color: '#242424' }}>{email}</Typography>
                </Box>
              ))}
            </Grid>
            <Grid item xs={4} sm={3}>
              <Typography sx={{ ...valueStyle, mb: 0.5 }}>SMS(s):</Typography>
              {connection.sms_list.map(sms => (
                <Box key={sms} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={treeConnector} />
                  <Typography sx={{ fontSize: '14px!important', color: '#242424' }}>{sms}</Typography>
                </Box>
              ))}
            </Grid>
            {config.connection_type === 'Alltel Transfer' && <Grid item xs={4} sm={3}>
              <Typography sx={{ ...valueStyle, mb: 0.5 }}>Transfer(s):</Typography>
              {connection.transfer_list.map(transfer => (
                <Box key={transfer} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={treeConnector} />
                  <Typography sx={{ fontSize: '14px!important', color: '#242424' }}>{transfer}</Typography>
                </Box>
              ))}
            </Grid>}
          </Fragment>
        })}
      </Grid>
    </Grid>
  </Grid>
}

export default LiveAnsweringConfig
